export default __webpack_public_path__ + "static/media/exchange.65f0b2c4.svg";